import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/api/client';

/**
 * §11.13 Layer 2 — submit the customer's outage decision.
 *
 * The choice (WAIT_IT_OUT / CANCEL_NOW) is baked into the signed CTA token, so
 * the request carries only `{ token }` — the backend derives and verifies the
 * choice from the HS512 signature. Public/unauthenticated: `skipAuth` keeps the
 * bearer header (and its refresh retry) off this call.
 *
 * Success → 200 `{ status: 'RECORDED' }` (idempotent — a repeat is also 200).
 * The client wrapper throws `AppError` with `status` 410 (window closed) or
 * 401 (invalid/expired token) — the page branches on that.
 */
export type OutageDecisionResult = { status: string };

export function useOutageDecision() {
  return useMutation({
    mutationFn: (token: string) =>
      apiClient<OutageDecisionResult>('/customer/outage-decision', {
        method: 'POST',
        body: JSON.stringify({ token }),
        skipAuth: true,
      }),
  });
}
